import { render } from "./UpperMenu.vue?vue&type=template&id=f1c98ee2"
import script from "./UpperMenu.vue?vue&type=script&lang=js"
export * from "./UpperMenu.vue?vue&type=script&lang=js"

import "./UpperMenu.vue?vue&type=style&index=0&id=f1c98ee2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/header/UpperMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f1c98ee2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f1c98ee2', __exports__)) {
    api.reload('f1c98ee2', __exports__)
  }
  
  module.hot.accept("./UpperMenu.vue?vue&type=template&id=f1c98ee2", () => {
    api.rerender('f1c98ee2', render)
  })

}


export default __exports__